import { CommandRegistry } from "../commands/CommandRegistry";
import { normalizeDocument } from "../normalize";
import { withHistory } from "../plugins";
import { Editor } from "./Editor";

export function createEditor(config) {
  let editor = new Editor(config.root);

  // Commands
  if (config.commands !== false) {
    editor.commands = new CommandRegistry(editor);
  }

  // History
  if (config.history !== false) {
    editor = withHistory(editor);
  }

  // Normalize
  if (config.normalize !== false) {
    editor.normalize = () => normalizeDocument(editor);
    // Gọi normalize lần đầu để tạo thẻ p nếu editor trống
    editor.normalize();
  }

  // Plugins
  config.plugins?.forEach((plugin) => {
    editor = plugin(editor);
  });

  return editor;
}
